<template>
	<div class="phonetable" style="position: relative;">
		<van-cell is-link @click="gridShow=true">
			<template #title>
				<van-tag type="primary" size="medium">明细：{{count}}</van-tag>
			</template>
		</van-cell>
		<van-popup v-model="gridShow" position="right" style="overflow: hidden;"
			:style="{ width: '100%',height:'100%' }" @opened="gridShowinit" :lazy-render="false"
			:safe-area-inset-bottom="true" get-container="body">
			<div class="full flex" style="flex-direction: column;">
				<div style="flex: 1;">
					<phone-grid :store="store" :ref="gridref" :gridOptions="gridOptions" :fields="fields" type="table"
						:key="gridKey" v-if="gridOptions" @toolbar-button-click="toolbarButtonClickEvent" @operate-button-click="operateButtonClickEvent"
						@tablefieldChange="tablefieldChange" @aftertabledelete="aftertabledelete"
						@edit-closed="editClosed" @dataChange="dataChange">
					</phone-grid>
				</div>
				<div class="flex">
					<van-button type="default" style="flex: 1;" @click="gridShow=false">返回</van-button>
				</div>
			</div>
		</van-popup>

		<!-- 		<box :readonly="readonly" :disabled="disabled" :ref="boxRef" :title="button.props.title"
			:index="button.props.index" :group="button.props.group" :width="button.props.width"
			:moduleName="button.props.moduleName" @submit="submit" :store="store" code="0" :popoverDisabled="true" /> -->
	</div>
</template>

<script>
	import tableBase from '@_system/components/base/table.vue'
	export default {
		extends: tableBase,
		props: {

		},
		data() {
			return {
				gridShow: false,
				count: 0,
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {


		},
		computed: {

		},

		methods: {
			gridShowinit() {

			},
			tablefieldChange(e) {

				e.store = this.store
				e.moduleName = this.moduleName
				e.table = this.$refs[this.gridref]
				this.$emit('tablefieldChange', e)
			},
			aftertabledelete(e) {
				e.moduleName = this.moduleName
				e.table = this.$refs[this.gridref]
				this.$emit('aftertabledelete', e)
			},

			dataChange(e) {
				this.count = e.page.total
				if (e.pageneed === false) {
					this.count = e.data.length
				}

			}
			// submit() {
			// 	return new Promise((resolve, reject) => {
			// 		let grid = this.$refs[this.gridref]
			// 		const {
			// 			insertRecords,
			// 			removeRecords,
			// 			updateRecords
			// 		} = grid.getRecordset()
			// 		grid.validate(false, (res) => {
			// 			if (!res) {
			// 				console.log({
			// 					insertRecords: insertRecords,
			// 					removeRecords: removeRecords,
			// 					updateRecords: updateRecords
			// 				})
			// 				reject({
			// 					insertRecords: insertRecords,
			// 					removeRecords: removeRecords,
			// 					updateRecords: updateRecords
			// 				})
			// 			} else {
			// 				for (let i in res) {
			// 					this.$message.error('缺少必填项：' + res[i][0].column.title)
			// 				}
			// 				reject()
			// 			}
			// 		})
			// 	})
			// }
		},
		components: {


		}
	}
</script>